import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoRightClick]'
})
export class NoRightClickDirective {

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

  // @HostListener('keydown', ['$event'])
  // onKeyDown(event) {
  //   console.log(event);
  //   if (event.key == "Control") {
  //     event.target.disabled = true;
  //     event.preventDefault();
  //   }
  //   if (event.key == "Shift") {
  //     event.target.disabled = true;
  //     event.preventDefault();
  //   }
  // }

  // @HostListener('window:popstate', ['$event'])
  // onPopState(event) {
  //   alert('Back button pressed');
  // }


  constructor(private el: ElementRef){        
    // console.log("constructor triggered", el);
  }

}